import tableOperation from '../common/table-operation'

const fetchLocalNumberPools = async function (
  { commit, state, getters },
  config
) {
  const { paginationConfig } = config
  commit('setTable', paginationConfig)

  const filteredCollection = getters.getSearchedNumberPools
  commit('setTableRecordsCount', filteredCollection?.length)

  const result = tableOperation.getPaginatedCollection({
    collection: [...filteredCollection],
    paginationConfig: paginationConfig,
  })

  return Promise.resolve(result)
}

export default fetchLocalNumberPools
